import VueI18n from 'vue-i18n'
import { backendUrl } from './endpointConfig'
import { language } from './language'

export const translationLoaded = {
  loaded: false,
}

export function init() {

  const i18n = new VueI18n({
    locale: language, // set locale
    fallbackLocale: 'en',
    messages: {},
  })

  loadLanguage(language, i18n).then(() => (translationLoaded.loaded = true))
  if (language !== 'en') {
    loadLanguage('en', i18n)
  }
  return i18n
}

async function loadLanguage(lang, i18n) {
  const request = await fetch(backendUrl + `translations/${lang}/soundwave.json`)
    const messages = await request.json()
    
  i18n.setLocaleMessage(lang, messages)
}
